import React, {Component} from 'react';
import Page from '../../components/Page';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { TwitterPicker } from 'react-color';
import _ from 'lodash';
import Modal from 'react-responsive-modal';
import './styles.css';
import {getUsers, updateUser, createUser, deleteUser} from '../../actions/users';
import {getProjects} from '../../actions/projects';


const DEFAULT_STATE = {
    open: false,
    action: '',
    _id: '',
    email: '',
    isActive: false,
    password: '',
    firstName: '',
    lastName: '',
    mac: '',
    roles: [],
    projects: [],
    color: '22194D',
    vacationDaysPerYear: 0,
    vacationDaysAvailable: 0,
};

class Users extends Component {

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
        this._onClickEdit = this._onClickEdit.bind(this);
        this._onClickRemove = this._onClickRemove.bind(this);
        this._onCloseModal = this._onCloseModal.bind(this);
        this._onChangeInput = this._onChangeInput.bind(this);
        this._onChangeCheckBox = this._onChangeCheckBox.bind(this);
        this._onChangeSingleValueCheckBox = this._onChangeSingleValueCheckBox.bind(this);
        this._onClickAction = this._onClickAction.bind(this);
        this._onClickCreate = this._onClickCreate.bind(this);
        this._onChangeColor = this._onChangeColor.bind(this);
    }

    componentWillMount() {
        this.props.dispatch(getUsers());
        this.props.dispatch(getProjects());
    }

    _onClickEdit(user) {
        let state = Object.assign({}, {open :true, action: 'Edit'}, _.omit(user, ['createdAt', 'updatedAt']));
        this.setState(state);
    }

    _onClickCreate() {
        let state = Object.assign({}, DEFAULT_STATE, {open :true, action: 'Create'});
        this.setState(state);
    }

    _onClickAction() {
        let omits = ['_id', 'open', 'action'];
        if (this.state.action === 'Edit') {
            if (this.state.password === '') {
                omits.push('password');
            }
            let data = _.omit(this.state, omits);
            this.props.dispatch(updateUser((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, this.state._id, data));
        } else if (this.state.action === 'Create') {
            let data = _.omit(this.state, omits);
            this.props.dispatch(createUser((error, json)=> {
                if (!error) {
                    let state = Object.assign({}, DEFAULT_STATE);
                    this.setState(state);
                }
            }, data));
        }
    }

    _onClickRemove(id) {
        this.props.dispatch(deleteUser(()=> {}, id));
    }

    _onCloseModal() {
        let state = Object.assign({}, DEFAULT_STATE);
        this.setState(state);
    };

    _onChangeInput(property, event) {
        let state = Object.assign({}, this.state);
        state[property] = event.target.value;
        this.setState(state);
    }

    _onChangeColor(color) {
        let state = Object.assign({}, this.state);
        state.color = color.hex;
        this.setState(state);
    }

    _onChangeCheckBox(property, type, event) {
        let state = Object.assign({}, this.state);
        let index = state[property].indexOf(type);
        if (index === -1) {
            state[property].push(type);
        } else {
            state[property].splice(index, 1);
        }
        this.setState(state);
    }

    _onChangeSingleValueCheckBox(property, event) {
        let state = Object.assign({}, this.state);
        if (state[property]) {
            state[property] = false;
        } else {
            state[property]  = true;
        }
        this.setState(state);
    }


    render() {
        let users = [];
        this.props.users.forEach((user, index) => {
            let isAdminUser = (user.roles && user.roles.indexOf('admin') !== -1);
            users.push(<tr key={'user_' + index}>
                <td><span className="color-dot" style={{background: user.color || '#F78DA7'}}></span></td>
                <td>{user.email}</td>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.isActive
                    ? <span className="Badge Badge--approved">Active</span>
                    : <span className="Badge Badge--canceled">Inactive</span>}</td>
                <td className="tabular text-muted-2">{user.mac}</td>
                <td>{isAdminUser ? <span className="Badge Badge--pending">Admin</span> : <span className="text-muted-2">Member</span>}</td>
                <td className="tabular">{user.vacationDaysPerYear}</td>
                <td className="tabular">{user.vacationDaysAvailable}</td>
                <td style={{textAlign: 'center'}}>
                    <button title="Edit user" onClick={()=> this._onClickEdit(user)} className="btn btn-default">
                        <i className="fa fa-pencil" style={{color: 'var(--brand-700)'}} aria-hidden="true"></i>
                    </button>
                </td>
            </tr>);

        });
        if (!users.length) {
            users.push(<tr key="users_empty"><td colSpan="10"><div className="Empty"><i className="fa fa-users" /><div className="t">No users yet</div></div></td></tr>);
        }

        let projects = [];

        this.props.projects.forEach((project, index) => {
            projects.push(<label key={'proj_' + index} className="Check-Row">
                <input type="checkbox"
                       checked={(this.state.projects.indexOf(project._id) !== -1)}
                       onChange={event => this._onChangeCheckBox('projects', project._id, event)}
                /> {project.name}
            </label>);
        });



        return (
            <Page {...this.props} >

                <Modal open={this.state.open} onClose={this._onCloseModal} little>

                    <div className="Modal-Head"><h3>{this.state.action === 'Create' ? 'New user' : 'Edit user'}</h3></div>

                    <div className="Modal-Body">
                        <div className="Input-Group">
                            <label>Email</label>
                            <input type="email" className="form-control" placeholder="user@domain.com"
                                   value={this.state.email}
                                   onChange={event => this._onChangeInput('email', event)}
                            />
                        </div>

                        <div className="Input-Group">
                            <label>Password</label>
                            <input type="password" className="form-control" placeholder="Set password"
                                   value={this.state.password}
                                   onChange={event => this._onChangeInput('password', event)}
                            />
                        </div>

                        <div className="Field-Row">
                            <div className="Input-Group">
                                <label>First name</label>
                                <input type="text" className="form-control" placeholder="John"
                                       value={this.state.firstName}
                                       onChange={event => this._onChangeInput('firstName', event)}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Last name</label>
                                <input type="text" className="form-control" placeholder="Doe"
                                       value={this.state.lastName}
                                       onChange={event => this._onChangeInput('lastName', event)}
                                />
                            </div>
                        </div>

                        <div className="Input-Group">
                            <label>MAC address</label>
                            <input type="text" className="form-control" placeholder="00:00:00:00:00:00"
                                   value={this.state.mac}
                                   onChange={event => this._onChangeInput('mac', event)}
                            />
                        </div>

                        <div className="Field-Row">
                            <label className="Check-Row">
                                <input type="checkbox"
                                       checked={this.state.isActive}
                                       onChange={event => this._onChangeSingleValueCheckBox('isActive', event)}
                                /> Active
                            </label>
                            <label className="Check-Row">
                                <input type="checkbox"
                                       checked={(this.state.roles.indexOf('admin') !== -1)}
                                       onChange={event => this._onChangeCheckBox('roles', 'admin', event)}
                                /> Admin
                            </label>
                        </div>

                        <div className="Field-Row">
                            <div className="Input-Group">
                                <label>Vacation days per year</label>
                                <input type="number" className="form-control" placeholder="21"
                                       value={this.state.vacationDaysPerYear}
                                       onChange={event => this._onChangeInput('vacationDaysPerYear', event)}
                                />
                            </div>
                            <div className="Input-Group">
                                <label>Vacation days available</label>
                                <input type="number" className="form-control" placeholder="21"
                                       value={this.state.vacationDaysAvailable}
                                       onChange={event => this._onChangeInput('vacationDaysAvailable', event)}
                                />
                            </div>
                        </div>

                        <div className="Input-Group">
                            <label>Projects</label>
                            {projects.length ? projects : <div className="text-muted-2">No projects available.</div>}
                        </div>

                        <div className="Input-Group">
                            <label>Calendar color</label>
                            <TwitterPicker
                                color={ this.state.color }
                                onChangeComplete={ this._onChangeColor }
                            />
                        </div>
                    </div>

                    <div className="Modal-Foot">
                        <button type="button" className="btn btn-default" onClick={this._onCloseModal}>Cancel</button>
                        <button type="button" className="btn btn-primary" onClick={this._onClickAction}>
                            {this.state.action === 'Create' ? 'Create user' : 'Save changes'}
                        </button>
                    </div>

                </Modal>

                <div className="col-xs-12">
                    <div className="Plus-Icon" title="Create user" onClick={this._onClickCreate}>
                        <i className="fa fa-plus-circle" aria-hidden="true"></i>
                    </div>
                    <div className="Card" style={{padding: 0}}>
                        <div className="Table-Wrap" style={{border: 0}}>
                            <table className="table">
                                <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Email</th>
                                    <th scope="col">First</th>
                                    <th scope="col">Last</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">MAC</th>
                                    <th scope="col">Role</th>
                                    <th scope="col">Days / year</th>
                                    <th scope="col">Available</th>
                                    <th scope="col" style={{textAlign: 'center'}}>Actions</th>
                                </tr>
                                </thead>
                                <tbody>
                                {users}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </Page>
        );
    }
}

Users.propTypes = {
    users: PropTypes.arrayOf(PropTypes.object),
    projects: PropTypes.arrayOf(PropTypes.object),

};

Users.defaultProps = {
    users: [],
    projects: [],
};


function mapStateToProps(state) {
    const users = state.users;
    const projects = state.projects;
    return {
        users: users,
        projects: projects,
    };
}

export default connect(mapStateToProps)(Users);



// WEBPACK FOOTER //
// ./src/screens/Users/index.js